import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";

interface ProposalGalleryImage {
  id: string;
  image_url: string;
  title: string;
  caption?: string;
  display_order: number;
}

export function ProposalGallery() {
  const [images, setImages] = useState<ProposalGalleryImage[]>([]);

  useEffect(() => {
    loadProposalImages();
  }, []);

  const loadProposalImages = async () => {
    const { data } = await supabase
      .from('proposal_gallery')
      .select('*')
      .eq('is_active', true)
      .order('display_order')
      .limit(6);
    
    setImages(data || []);
  };

  if (images.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {images.map((image) => (
        <Card key={image.id} className="overflow-hidden page-break-inside-avoid">
          <CardContent className="p-0">
            <div className="aspect-video relative">
              <img
                src={image.image_url}
                alt={image.title}
                className="w-full h-full object-cover"
              />
            </div>
            {image.caption && (
              <div className="p-4">
                <p className="text-sm text-muted-foreground">{image.caption}</p>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
